import Vue from 'vue';
import App from './App.vue';
import router from './router';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './assets/css/global.scss';
import VueCookies from 'vue-cookies';

Vue.config.productionTip = false;

// Use plugins
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueCookies);

// Navbar scroll effect and active section highlighting
window.addEventListener('scroll', () => {
  const navbar = document.querySelector('.modern-navbar');
  if (navbar) {
    if (window.scrollY > 50) {
      navbar.classList.add('scrolled');
    } else {
      navbar.classList.remove('scrolled');
    }
  }
  
  // Highlight active section in navigation
  const sections = document.querySelectorAll('section[id]');
  const navLinks = document.querySelectorAll('.navbar-nav .nav-link');
  
  let currentSection = '';
  sections.forEach(section => {
    const sectionTop = section.offsetTop;
    if (window.scrollY >= (sectionTop - 200)) {
      currentSection = section.getAttribute('id');
    }
  });

  navLinks.forEach(link => {
    link.classList.remove('active');
    const href = link.getAttribute('href');
    if (href && (href === `#${currentSection}` || href.endsWith(`#${currentSection}`))) {
      link.classList.add('active');
    }
  });
});

// Add smooth scrolling for hash links
// This function handles both direct hash links and router hash links
function setupSmoothScrolling() {
  // Handle direct hash links
  document.querySelectorAll('a[href^="#"]:not([href*="/#"])').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();
      
      const targetId = this.getAttribute('href').substring(1);
      const targetElement = document.getElementById(targetId);
      
      if (targetElement) {
        window.scrollTo({
          top: targetElement.offsetTop - 70, // Offset for fixed navbar
          behavior: 'smooth'
        });
      }
    });
  });
}

// Setup smooth scrolling when DOM is ready
document.addEventListener('DOMContentLoaded', setupSmoothScrolling);

// Also set up smooth scrolling after route changes
window.addEventListener('hashchange', () => {
  // Extract the hash from the URL
  const hash = window.location.hash;
  if (hash && hash.includes('#')) {
    // Get the target element
    const targetId = hash.split('#').pop();
    const targetElement = document.getElementById(targetId);
    
    if (targetElement) {
      // Small timeout to ensure the page has rendered
      setTimeout(() => {
        window.scrollTo({
          top: targetElement.offsetTop - 70, // Offset for fixed navbar
          behavior: 'smooth'
        });
      }, 100);
    }
  }
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
